module.exports = "/_next/static/images/546ffa8784c3eaae65e29fed0a714933-credit-zero-rate.svg";